import { useEffect } from "react";
import { BACKEND_URL } from "../lib/api";

const SITE_NAME = "Loft Press";
const DEFAULT_DESCRIPTION = "En güncel haberler, teknoloji, spor, ekonomi, gündem ve daha fazlası. Bağımsız ve tarafsız haber platformu.";
const DEFAULT_IMAGE = BACKEND_URL + "/icon-512.png";

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setJsonLd = (data) => {
  let el = document.querySelector('script[data-seo-jsonld]');
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo-jsonld", "true");
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

const setCanonical = (url) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = url;
};

const SEO = ({ title, description, image, type }) => {
  useEffect(() => {
    const desc = description || DEFAULT_DESCRIPTION;
    const img = image || DEFAULT_IMAGE;
    const pageType = type || "website";
    const fullTitle = title ? title + " | " + SITE_NAME : SITE_NAME + " - Bağımsız Haber";

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:type", pageType);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", img);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:locale", "tr_TR");
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
    setCanonical(window.location.href);

    setJsonLd({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": SITE_NAME,
      "url": BACKEND_URL,
      "description": DEFAULT_DESCRIPTION,
      "publisher": { "@type": "Organization", "name": SITE_NAME }
    });
  }, [title, description, image, type]);

  return null;
};

export const ArticleSEO = ({ news }) => {
  useEffect(() => {
    if (!news) return;

    const fullTitle = news.title + " | " + SITE_NAME;
    document.title = fullTitle;
    setMeta("name", "description", news.summary || "");
    setMeta("property", "og:type", "article");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", news.summary || "");
    setMeta("property", "og:image", news.image_url || DEFAULT_IMAGE);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:locale", "tr_TR");
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "article:published_time", news.created_at || "");
    setMeta("property", "article:author", news.author || SITE_NAME);
    setMeta("property", "article:section", news.category || "");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", news.summary || "");
    setMeta("name", "twitter:image", news.image_url || DEFAULT_IMAGE);
    setCanonical(window.location.href);

    setJsonLd({
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      "headline": news.title,
      "description": news.summary,
      "image": news.image_url,
      "datePublished": news.created_at,
      "dateModified": news.updated_at || news.created_at,
      "author": { "@type": "Organization", "name": news.author || SITE_NAME },
      "publisher": { "@type": "Organization", "name": SITE_NAME, "logo": { "@type": "ImageObject", "url": DEFAULT_IMAGE } },
      "articleSection": news.category
    });
  }, [news]);

  return null;
};

export default SEO;
